<nav class="breadcrumb-nav" *ngIf="items.length > 1" aria-label="breadcrumb">
  <ol class="breadcrumb-list">
    <li *ngFor="let item of items" class="breadcrumb-item" [class.active]="item.isLast">
      <a *ngIf="!item.isLast" [routerLink]="item.url" class="breadcrumb-link">
        {{ item.label }}
      </a>
      <span *ngIf="item.isLast" class="breadcrumb-current">{{ item.label }}</span>
      <span *ngIf="!item.isLast" class="breadcrumb-separator">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </li>
  </ol>
</nav>
